import {setup, run} from '../../snippets/java';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  'run-server': {
    Component: CreateShellCommand(run('stripe-checkout')),
  },
};

export default ({
  keys,
  merchant,
  client,
  demo: {paymentMethods},
  activePrice,
  checkoutMode,
}) => `package com.stripe.sample;

import java.nio.file.Paths;

import static spark.Spark.post;
import static spark.Spark.port;
import static spark.Spark.staticFiles;

{+setup}
import com.stripe.Stripe;
import com.stripe.model.checkout.Session;
import com.stripe.param.checkout.SessionCreateParams;
{/setup}

public class Server {

  public static void main(String[] args) {
    port(4242);

    ${comment && comment(merchant)}
    Stripe.apiKey = "${keys.secret}";

    staticFiles.externalLocation(
        Paths.get("public").toAbsolutePath().toString());

    post("/create-checkout-session", (request, response) -> {

        String YOUR_DOMAIN = "${
          client === 'react'
            ? 'http://localhost:3000/checkout'
            : 'http://localhost:4242'
        }";
        {+create}
        SessionCreateParams params =
          SessionCreateParams.builder()
            {?customize prefill-email}
            .setCustomerEmail("customer@example.com")
            {/prefill-email}
            {?customize submit-button}
            .setSubmitType(SessionCreateParams.SubmitType.DONATE)
            {/submit-button}
            {?customize address}
            .setBillingAddressCollection(SessionCreateParams.BillingAddressCollection.REQUIRED)
            .setShippingAddressCollection(
              SessionCreateParams.ShippingAddressCollection.builder()
                .addAllowedCountry(SessionCreateParams.ShippingAddressCollection.AllowedCountry.CA)
                .addAllowedCountry(SessionCreateParams.ShippingAddressCollection.AllowedCountry.US)
                .build())
            {/address}
            {+payment-methods}
            ${
              paymentMethods.length
                ? paymentMethods
                    .map(
                      (key) =>
                        `.addPaymentMethodType(SessionCreateParams.PaymentMethodType.${key.toUpperCase()})`,
                    )
                    .join('\n            ')
                : '// TODO: pass at least one option here'
            }
            {/payment-methods}
            {+mode}
            .setMode(SessionCreateParams.Mode.${checkoutMode.toUpperCase()})
            {/mode}
            {+urls}
            .setSuccessUrl(YOUR_DOMAIN + "${
              client === 'react' ? '?success=true' : '/success.html'
            }")
            .setCancelUrl(YOUR_DOMAIN + "${
              client === 'react' ? '?canceled=true' : '/cancel.html'
            }")
            {/urls}
            {?automatic-tax automatic-tax-param}
            .setAutomaticTax(
              SessionCreateParams.AutomaticTax.builder()
                .setEnabled(true)
                .build())
            {/automatic-tax-param}
            {+line-items}
            .addLineItem(
              SessionCreateParams.LineItem.builder()
                .setQuantity(1L)
                ${
                  activePrice
                    ? `.setPrice("${activePrice.id}")`
                    : `// TODO: replace this with the \`price\` of the product you want to sell
                .setPrice("{{PRICE_ID}}")`
                }
                .build())
            {/line-items}
            .build();
      {/create}
      Session session = Session.create(params);

      {+redirect}
      response.redirect(session.getUrl(), 303);
      return "";
      {/redirect}
    });
  }
}`;
